import request from '@/utils/request'

/**
 * 仪表盘相关接口
 */

export const dashboardApi = {
  // 获取仪表盘统计数据
  getDashboardStats(params = {}) {
    return request({
      url: '/inventory-management-api/home/dashboard',
      method: 'POST',
      data: params
    })
  }
}